import { Directive, input } from '@angular/core';

/** The inner margin of a card: none for content that runs to the edge, 16px or 20px otherwise. */
export type MibCardPadding = 'none' | 'md' | 'lg';

/** The surface alone, for a component that is a card on its own host rather than wearing `mibCard`. */
export const MIB_CARD_SURFACE = 'rounded-mib border border-mib-divider bg-white';

/**
 * The surface of a card: a white ground, the divider line and the 4px radius. Its content is free.
 *
 * ```html
 * <section mibCard>…</section>
 * <div mibCard padding="none">…</div>
 * ```
 */
@Directive({
  selector: '[mibCard]',
  host: {
    class: MIB_CARD_SURFACE,
    '[class.p-4]': "padding() === 'md'",
    '[class.p-5]': "padding() === 'lg'",
  },
})
export class MibCardDirective {
  readonly padding = input<MibCardPadding>('md');
}
